












import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class VBar extends Vue {
  @Prop() color?: string;

  get style() {
    return {
      backgroundColor: this.color
    };
  }
}
